<div class="demo-page saved-card-page">
  <div class="layout">
    <!-- Simulador de app (teléfono) -->
    <div class="phone-column">
      <div class="phone-shell">
        <div class="phone-side-button phone-side-button--left"></div>
        <div class="phone-side-button phone-side-button--right"></div>

        <div class="phone-frame">
          <div class="phone-status-bar">
            <span class="status-time">{{ currentTimeLabel }}</span>
            <div class="status-notch" aria-hidden="true"></div>
            <div class="status-icons" aria-hidden="true">
              <span class="status-dot"></span>
              <span class="status-dot"></span>
              <span class="status-battery"></span>
            </div>
          </div>

          <div class="phone-screen">
            <header class="app-header">
              <div class="app-header-brand">
                <span class="app-logo">e</span>
                <div>
                  <span class="app-title">Billetera Epago</span>
                  <span class="app-subtitle">Simulador móvil</span>
                </div>
              </div>
              <span class="app-badge">{{ selectedApiEnv }}</span>
            </header>

            <div class="screen-body" [ngSwitch]="appScreen">
              <!-- Home -->
              <div *ngSwitchCase="'home'" class="screen home-screen">
                <div class="hero-block">
                  <div class="hero-icon">
                    <ng-icon name="lucideNfc" size="28"></ng-icon>
                  </div>
                  <h2>Pago tokenizado</h2>
                  <p>Flujo completo de app: registro opcional, consulta de tarjetas y cobro con token.</p>
                </div>

                <div class="flow-steps">
                  <div class="flow-step">
                    <span class="step-num">1</span>
                    <div>
                      <strong>Registrar tarjeta</strong>
                      <small>Opcional · webview PayLink</small>
                    </div>
                  </div>
                  <div class="flow-step">
                    <span class="step-num">2</span>
                    <div>
                      <strong>Elegir tarjeta</strong>
                      <small>Consulta las veces que quieras</small>
                    </div>
                  </div>
                  <div class="flow-step">
                    <span class="step-num">3</span>
                    <div>
                      <strong>Pagar producto</strong>
                      <small>Auth invisible + 3DS si aplica</small>
                    </div>
                  </div>
                </div>

                <div class="screen-actions">
                  <button mat-raised-button color="primary" class="app-btn app-btn--primary" (click)="startCardRegister()" [disabled]="isLoading">
                    <ng-icon name="lucidePlus" size="18"></ng-icon>
                    Registrar tarjeta
                  </button>
                  <button mat-stroked-button class="app-btn app-btn--ghost" (click)="skipRegisterAndGoToCards()" [disabled]="isLoading">
                    Ir a mis tarjetas
                  </button>
                </div>
              </div>

              <!-- Cards -->
              <div *ngSwitchCase="'cards'" class="screen cards-screen">
                <div class="screen-toolbar">
                  <button type="button" class="console-icon-btn toolbar-back" (click)="appScreen = 'home'" aria-label="Volver">
                    <ng-icon name="lucideArrowLeft" size="18"></ng-icon>
                  </button>
                  <div class="toolbar-title">
                    <h3>Mis tarjetas</h3>
                    <span>{{ cards.length }} guardadas</span>
                  </div>
                  <button type="button" class="console-icon-btn toolbar-refresh" (click)="consultCards()" [disabled]="isLoading" aria-label="Actualizar">
                    <ng-icon name="lucideRefreshCw" size="18"></ng-icon>
                  </button>
                </div>

                <div *ngIf="!cards.length && !isLoading" class="empty-wallet">
                  <ng-icon name="lucideBan" size="32"></ng-icon>
                  <p>Sin tarjetas cargadas</p>
                  <button mat-stroked-button (click)="consultCards()">Consultar ahora</button>
                </div>

                <div *ngIf="isLoading && !cards.length" class="loading-wallet">
                  <mat-spinner diameter="36"></mat-spinner>
                  <span>Consultando tarjetas...</span>
                </div>

                <div class="wallet-list" *ngIf="cards.length">
                  <button
                    type="button"
                    class="wallet-card"
                    *ngFor="let card of cards"
                    [class.wallet-card--selected]="selectedCardToken === card.token"
                    [ngClass]="getCardBrandClass(card.brand)"
                    (click)="selectCard(card)">
                    <div class="wallet-card-shine"></div>
                    <div class="wallet-card-top">
                      <ng-icon name="lucideNfc" size="28"></ng-icon>
                      <span class="wallet-card-brand">{{ card.brand }}</span>
                      <ng-icon class="wallet-card-check" name="lucideCircleCheck" size="20" *ngIf="selectedCardToken === card.token"></ng-icon>
                    </div>
                    <div class="wallet-card-number">{{ card.masked }}</div>
                    <div class="wallet-card-meta">
                      <div>
                        <small>Titular</small>
                        <span>{{ card.cardName }}</span>
                      </div>
                      <div>
                        <small>Vence</small>
                        <span>{{ card.expiration }}</span>
                      </div>
                    </div>
                    <div class="wallet-card-footer" *ngIf="card.alias || card.defaultCard">
                      <span class="wallet-alias" *ngIf="card.alias">{{ card.alias }}</span>
                      <span class="wallet-default" *ngIf="card.defaultCard">Principal</span>
                    </div>
                  </button>
                </div>

                <div class="checkout-bar" *ngIf="selectedCard">
                  <div class="checkout-info">
                    <small>Total a pagar</small>
                    <strong>{{ myForm.get('currencyCode')?.value }} {{ myForm.get('amount')?.value | number:'1.2-2' }}</strong>
                    <span>{{ selectedCardLabel }}</span>
                  </div>
                  <button
                    mat-fab
                    color="accent"
                    class="checkout-fab"
                    (click)="payWithSelectedCard()"
                    [disabled]="isLoading"
                    aria-label="Pagar">
                    <ng-icon [name]="isLoading ? 'lucideLoader2' : 'lucideLock'" size="18" [class.console-btn__icon--spin]="isLoading"></ng-icon>
                  </button>
                </div>

                <button
                  *ngIf="!selectedCard && cards.length"
                  mat-raised-button
                  color="accent"
                  class="app-btn app-btn--pay"
                  disabled>
                  Selecciona una tarjeta
                </button>
              </div>

              <!-- Waiting -->
              <div *ngSwitchCase="'waiting'" class="screen waiting-screen">
                <div class="waiting-visual">
                  <div class="waiting-ring" [class.waiting-ring--active]="showWaitingSpinner">
                    <mat-spinner *ngIf="showWaitingSpinner" diameter="52"></mat-spinner>
                    <ng-icon *ngIf="!showWaitingSpinner" name="lucideShieldCheck" size="28"></ng-icon>
                  </div>
                </div>
                <h3>{{ waitingMessage }}</h3>
                <p>No cierres esta pantalla mientras autenticamos tu pago.</p>
                <div class="waiting-steps">
                  <span class="waiting-step waiting-step--done">Autorizando</span>
                  <span class="waiting-step" [class.waiting-step--done]="!showWaitingSpinner">Validación banco</span>
                  <span class="waiting-step">Confirmación</span>
                </div>
              </div>

              <!-- Result -->
              <div *ngSwitchCase="'result'" class="screen result-screen">
                <div class="result-visual" [class.result-visual--success]="paymentResult?.success" [class.result-visual--error]="!paymentResult?.success">
                  <ng-icon [name]="paymentResult?.success ? 'lucideCircleCheck' : 'lucideCircleX'" size="40"></ng-icon>
                </div>
                <h3>{{ paymentResult?.success ? '¡Pago exitoso!' : 'Pago no completado' }}</h3>
                <p class="result-message">{{ paymentResult?.message }}</p>
                <p *ngIf="paymentResult?.code" class="result-code">{{ paymentResult?.code }}</p>

                <div class="result-timing" *ngIf="latencyEntries.length">
                  <h4>Tiempos del flujo</h4>
                  <p class="result-timing-note">Suma de duraciones medidas. No incluye tiempo de selección manual.</p>
                  <div class="result-timing-summary">
                    <div class="timing-total timing-total--flow" *ngIf="hasConsultPhase && hasPaymentPhase">
                      <small>Flujo medido</small>
                      <strong>{{ formatDuration(totalFlowMs) }}</strong>
                    </div>
                    <div class="timing-total timing-total--consult" *ngIf="hasConsultPhase">
                      <small>Consulta medida</small>
                      <strong>{{ formatDuration(totalConsultMs) }}</strong>
                    </div>
                    <div class="timing-total timing-total--pay" *ngIf="hasPaymentPhase">
                      <small>Pago medido</small>
                      <strong>{{ formatDuration(totalPaymentMs) }}</strong>
                    </div>
                  </div>

                  <div class="result-timing-section" *ngIf="hasConsultPhase">
                    <h5>Consulta</h5>
                    <div class="result-timing-list">
                      <div class="result-timing-row" *ngFor="let entry of consultTimelineEntries">
                        <span class="result-timing-label">{{ entry.label }}</span>
                        <div class="result-timing-values">
                          <span class="result-timing-step">{{ formatDuration(entry.stepMs) }}</span>
                          <span class="result-timing-elapsed">Σ {{ formatDuration(entry.cumulativeMs) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="result-timing-section" *ngIf="hasPaymentPhase">
                    <h5>Pago</h5>
                    <div class="result-timing-list">
                      <div class="result-timing-row" *ngFor="let entry of paymentTimelineEntries">
                        <span class="result-timing-label">{{ entry.label }}</span>
                        <div class="result-timing-values">
                          <span class="result-timing-step">{{ formatDuration(entry.stepMs) }}</span>
                          <span class="result-timing-elapsed">Σ {{ formatDuration(entry.cumulativeMs) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <button mat-raised-button color="primary" class="app-btn app-btn--primary" (click)="resetFlow()">
                  <ng-icon name="lucideRotateCw" size="18"></ng-icon>
                  Nuevo flujo
                </button>
              </div>
            </div>

            <div class="phone-home-indicator" *ngIf="!showRegisterIframe && !authIframeVisible" aria-hidden="true"></div>

            <!-- Webview registro: cubre la app como en nativo -->
            <div *ngIf="showRegisterIframe" class="phone-webview">
              <div class="phone-webview-bar">
                <span>Registrar tarjeta</span>
                <button type="button" class="phone-webview-close" (click)="closeRegisterIframe()" aria-label="Cerrar">✕</button>
              </div>
              <iframe
                [src]="registerIframeUrl | safe:'resourceUrl'"
                class="phone-webview-iframe"
                frameborder="0"
                allowfullscreen
                (load)="onRegisterIframeLoad()">
              </iframe>
            </div>

            <!-- Auth: iframe invisible hasta challenge, luego cubre el teléfono -->
            <div *ngIf="showAuthOverlay" class="phone-auth-layer" [class.phone-auth-layer--challenge]="authIframeVisible">
              <div class="phone-webview-bar" *ngIf="authIframeVisible">
                <span>Validación del banco</span>
              </div>
              <iframe
                *ngIf="authIframeUrl"
                [src]="authIframeUrl | safe:'resourceUrl'"
                class="phone-auth-iframe"
                [class.phone-auth-iframe--visible]="authIframeVisible"
                [class.phone-auth-iframe--hidden]="!authIframeVisible"
                frameborder="0"
                (load)="onAuthIframeLoad()">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Panel de configuración y latencia -->
    <div class="config-column">
      <div class="config-console">
        <h2 class="config-console__title">Pago tokenizado</h2>
        <p class="config-console__subtitle">Configuración API y datos de prueba</p>
        <form [formGroup]="myForm" class="config-form">
          <app-console-section title="API">
            <div class="console-form-grid">
              <div class="console-field">
                <label class="console-field__label" for="sc-apiEnvironment">Ambiente API</label>
                <select id="sc-apiEnvironment" class="console-select" formControlName="apiEnvironment">
                  <option value="QA">QA — qas.api.epago.pe</option>
                  <option value="PRD">PRD — api.epago.pe</option>
                </select>
                <span class="console-field__hint">Endpoint: {{ selectedApiBaseUrl }}</span>
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-apiKey">API Key</label>
                <input id="sc-apiKey" class="console-input" formControlName="apiKey" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-secret">Secret</label>
                <input id="sc-secret" class="console-input" formControlName="secret" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-orderNumber">Número de orden</label>
                <input id="sc-orderNumber" class="console-input" formControlName="orderNumber" readonly />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-paymentMethod">Método de pago</label>
                <input id="sc-paymentMethod" class="console-input" formControlName="paymentMethod" />
              </div>
            </div>
          </app-console-section>

          <app-console-section title="Cliente">
            <div class="console-form-grid">
              <div class="console-field">
                <label class="console-field__label" for="sc-customerIdentifier">ID de cliente</label>
                <input id="sc-customerIdentifier" class="console-input" formControlName="customerIdentifier" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-email">Email</label>
                <input id="sc-email" class="console-input" formControlName="email" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-name">Nombre</label>
                <input id="sc-name" class="console-input" formControlName="name" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-lastName">Apellido</label>
                <input id="sc-lastName" class="console-input" formControlName="lastName" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-documentType">Tipo doc.</label>
                <select id="sc-documentType" class="console-select" formControlName="documentType">
                  <option value="DNI">DNI</option>
                  <option value="CE">CE</option>
                </select>
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-documentNumber">Número doc.</label>
                <input id="sc-documentNumber" class="console-input" formControlName="documentNumber" />
              </div>
            </div>
          </app-console-section>

          <app-console-section title="Pago">
            <div class="console-form-grid">
              <div class="console-field">
                <label class="console-field__label" for="sc-amount">Monto</label>
                <input id="sc-amount" type="number" class="console-input" formControlName="amount" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-installment">Cuotas</label>
                <input id="sc-installment" class="console-input" formControlName="installment" />
              </div>
              <div class="console-field">
                <label class="console-field__label" for="sc-deferredInstallment">Cuotas diferidas</label>
                <input id="sc-deferredInstallment" class="console-input" formControlName="deferredInstallment" />
              </div>
            </div>
          </app-console-section>
        </form>
        <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      </div>

      <mat-card class="latency-card">
        <mat-card-header>
          <mat-card-title>Línea de tiempo de latencia</mat-card-title>
          <mat-card-subtitle>Marcas de tiempo relativas al inicio del hito</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="!latencyEntries.length" class="empty-state">
            Aún no hay mediciones. El timeline arranca al consultar tarjetas o al autorizar saved-card.
          </div>
          <div class="latency-list" *ngIf="latencyEntries.length">
            <div class="latency-section" *ngIf="hasConsultPhase">
              <h5>Consulta</h5>
              <div class="latency-row" *ngFor="let entry of consultTimelineEntries">
                <span class="latency-label">{{ entry.label }}</span>
                <span class="latency-delta">{{ formatDuration(entry.stepMs) }} · Σ {{ formatDuration(entry.cumulativeMs) }}</span>
              </div>
            </div>
            <div class="latency-section" *ngIf="hasPaymentPhase">
              <h5>Pago</h5>
              <div class="latency-row" *ngFor="let entry of paymentTimelineEntries">
                <span class="latency-label">{{ entry.label }}</span>
                <span class="latency-delta">{{ formatDuration(entry.stepMs) }} · Σ {{ formatDuration(entry.cumulativeMs) }}</span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
